import React, { Component } from "react";
import {FormGenerator} from "@kehillahglobal/ui";
import URLS from "../../../../shared/js/urls";
import ApiCallHandler from "../../../../shared/js/ApiCallHandler";

import { bindActionCreators } from "redux";
import {
  toggleModalAction,
  toggleToastAction,
  editMutationAction,
} from "store/actions/actions";
import { connect } from "react-redux";
import { updateTypeDataInRedux, createDraftWithParentFormData, findAndReturnDraft } from '../../../../shared/js/globalReduxInteractions';
import { getRandomStringKey, hasEmptyFields } from '../../../../shared/js/utils';
import { getDealStatsAction } from '../../../../store/actions/actions';
import { numberValidator } from "shared/js/fieldValidators";

class CreateDealExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentData: {
        expense_type: "",
        amount: "",
        transaction_date: "",
        reference_id: "",
        receipt: "",
        notes: "",
      },
      formData: {},
      key: Math.random(),
    };
  }

  componentDidMount() {
    let { editData } = this.props;
    if (editData) {
      this.setState({ currentData: editData });
    }
  }
  static getDerivedStateFromProps(props, state) {
    if (props.editData) {
      return {
        currentData: hasEmptyFields(state.currentData)
          ? { ...props.editData, ...{} }
          : { ...props.editData, ...state.currentData },
      };
    }
    return null;
  }
  handleCreate = async (data, editData, reset) => {
    let { currentDeal } = this.props;
    let res;
    let toSend = {
      ...data,
      amount: parseFloat(data.amount),
      expense_type_id: data && data.expense_type ? data.expense_type.id : "",
      deal_id: currentDeal.id,
    };
     if (toSend?.expense_type) {
       delete toSend.expense_type;
     }
    if (data?.receipt?.data?.file?.data) {
      toSend.receipt = data.receipt.data.file.data;
    } else {
      delete toSend.receipt;
    }

    if (!editData?.id) {
      res = await ApiCallHandler.send(URLS.CREATE_DEAL_EXPENSE, "POST", {
        ...toSend,
      });
    } else {
      let newToSend = { ...toSend, id: editData?.id };
      res = await ApiCallHandler.send(
        URLS.EDIT_DEAL_EXPENSE,
        "POST",
        newToSend
      );
    }
    if (res && res.success) {
      this.updateReduxStore(editData?.id, res);
      let stats = await this.props.getOppStats(currentDeal.id);
      this.props.updateStats(stats?.payload)
      this.props.toggleToast({
        show: true,
        message: !editData?.id
          ? "Expense created successfully"
          : "Expense updated successfully",
        type: "success",
      });
      reset();
      this.props.toggleModal({ show: false });
    } else {
      this.props.toggleToast({
        showToast: true,
        message: "An error occurred. Try again",
        type: "failure",
      });
      this.props.toggleModal({ show: false });
    }
  };

  updateReduxStore = (is_edit, res) => {
    let { currentDeal } = this.props;
    let newExpenses;

    if (!is_edit) {
      newExpenses =
        currentDeal?.expenses?.length ||
        currentDeal?.expenses !== null
          ? [...currentDeal?.expenses, res?.data]
          : [res?.data];
    } else {
      const index = currentDeal?.expenses?.map((object) => object.id).indexOf(res?.data[0]?.id);

      newExpenses = currentDeal?.expenses?.filter(
        (item) => item?.id !== res?.data[0].id
      );
      newExpenses?.splice(index, 0, res?.data[0]);
    }
    currentDeal.expenses = newExpenses;
    this.props.updateItemInredux(this.props.deals, currentDeal);
  };

  close = () => {
    this.props.toggleModal({ show: false });
  };
  updateFields = (res) => {
    let { currentData } = this.state;
    let data = currentData;
    let draft = findAndReturnDraft(res?.draftId) || {};
    data = { ...data, ...draft };
    data.expense_type = res?.data;
    this.setState({ currentData: data, key: getRandomStringKey() });
  };

  render() {
    let {
      expenseTypes,
      editData,
    } = this.props;
    let getFieldValue = (field) => {
      let value = this.state.currentData[field] || "";
      return value;
    };
    const Fields = FormGenerator?.Fields
    return (
      <div key={this.state.key}>
        <FormGenerator
          elevation={0}
          fields={[
            {
              data: expenseTypes || [],
              fieldType: Fields.DROPDOWN,
              label: "Choose The Expense Type",
              name: "expense_type",
              placeholder: "Select Expense Type",
              required: true,
              type: "full",
              value: getFieldValue("expense_type"),
              labelExtractor: (item) => item.name,
              valueExtractor: (item) => item.id,
              child: {
                fields: [
                  {
                    fieldType: Fields.INPUT,
                    label: "Expense Type Name",
                    name: "name",
                    placeholder: "Enter Expense Type Name",
                    required: true,
                    value: "",
                  },
                ],
                metaData: {
                  endpoint: URLS.CREATE_NEW_DEAL_EXPENSE_TYPE,
                  additionalData: {
                    deal_id: this.props.currentDeal?.id,
                  },
                  onSuccess: (res) => {
                    updateTypeDataInRedux(
                      res?.data,
                      "expense_types",
                      this.props.currentDeal?.id
                    );
                    this.updateFields(res);
                  },
                  createDraft: (id) =>
                    createDraftWithParentFormData(this.state.formData, id),
                },
              },
            },
            {
              fieldType: Fields.INPUT,
              label: "Set Amount",
              name: "amount",
              placeholder: "How Much Was The Income ? Eg. 400",
              required: true,
              value: getFieldValue("amount") || 0,
              validator: (value) => numberValidator(value),
            },
            {
              fieldType: Fields.DATE,
              label: "Transaction date",
              name: "transaction_date",
              placeholder: "Select Date",
              required: true,
              value: getFieldValue("transaction_date"),
              // validator: (value) => dateValidator(value), :: removed because people should be able to enter date of 
              // transaction if it occurred in an earlier date
            },
            {
              fieldType: Fields.INPUT,
              label: "Enter Ref. Id",
              name: "reference_id",
              placeholder: "Enter Ref. Id",
              required: false,
              value: getFieldValue("reference_id"),
            },
            {
              fieldType: Fields.FILE,
              label: "Receipt",
              name: "receipt",
              placeholder: "Upload Receipt",
              required: false,
              value: getFieldValue("receipt"),
            },
            {
              fieldType: Fields.TEXTAREA,
              label: "Notes",
              name: "description",
              placeholder: "Short Notes Here...",
              value: getFieldValue("description"),
            },
          ]}
          onSubmit={(data, reset) => this.handleCreate(data, editData, reset)}
          formSubmitBtnText={!editData?.id ? "create Expense" : "Save Changes"}
          subtitle=""
          title=""
          onStateChange={(data) => this.setState({ formData: data })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownerProps) => {
  const currentDeal = state.deals?.find(
    (x) => x.id === ownerProps?.currentDeal
  );
  return {
    expenseTypes: currentDeal?.expense_types,
    currentDeal,
    deals: state.deals,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleToast: toggleToastAction,
      toggleModal: toggleModalAction,
      getOppStats: getDealStatsAction,
      updateItemInredux: (current_data, new_data) =>
        dispatch(editMutationAction("DEAL", current_data, new_data)),
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateDealExpense);
